import React, {useEffect} from 'react';
import store from "./OrderPageWidgetStore";
import {PopupDataDto} from "./Dtos";
import {observer} from "mobx-react-lite";
import OrderPage from "../../Pages/Orders/Order/OrderPage";
import orderStore from "../../Stores/OrderStore";

function OrderPageWidgetPage(props: { contextKey: string }) {
    const {contextKey} = props;
    useEffect(() => {
        function handleEvent(e: any) {
            const data = e.data as PopupDataDto;
            if (!data) return;

            if (data.name === "OpenPopup") {
                console.log(data);
                void store.init(contextKey, data.popupParameters.orderHrefId);
            }
        }

        window.addEventListener('message', handleEvent);
        return function cleanup() {
            window.removeEventListener('message', handleEvent);
            store.cleanup();
        }
    }, [contextKey]);
    if (orderStore.error) {
        return <>{orderStore.error}</>
    }
    return <>
        {store.orderId ? <OrderPage id={store.orderId}/> : "Загрузка..."}
    </>
}

export default observer(OrderPageWidgetPage);